export const SharedPersonCard = {
  hide: (el, s) => !(s && s.root && s.root.selectedPerson),
  position: 'fixed',
  zIndex: 1500,
  flow: 'y',
  gap: 'Z1',
  padding: 'A',
  width: 'H',
  round: 'Z2',
  theme: 'modal',
  borderWidth: '1px',
  borderColor: 'line',
  borderStyle: 'solid',
  boxShadow: '0 8px 24px var(--color-shadow)',
  top: (el, s) => (s && s.root && s.root.selectedPerson) ? `${s.root.selectedPerson.y}px` : '0',
  left: (el, s) => (s && s.root && s.root.selectedPerson) ? `${s.root.selectedPerson.x}px` : '0',

  onCreate: (el, s) => {
    el._closeOnOutside = (ev) => {
      if (!el.node) return
      if (el.node.contains(ev.target)) return
      if (ev.target.closest && ev.target.closest('[data-personrow]')) return
      if (s && s.root && s.root.update) s.root.update({ selectedPerson: null })
    }
    setTimeout(() => document.addEventListener('mousedown', el._closeOnOutside), 0)
  },
  onRemove: (el) => {
    if (el._closeOnOutside) document.removeEventListener('mousedown', el._closeOnOutside)
  },

  Header: {
    flow: 'x',
    align: 'center left',
    gap: 'Z1',

    Avatar: {
      avatarType: 'initials',
      boxSize: 'C C',
      src: (el, s) => el.call('avatarUrl', s && s.root && s.root.selectedPerson && s.root.selectedPerson.name)
    },
    Info: {
      flow: 'y',
      gap: 'Y2',
      flex: '1',
      Name: {
        tag: 'span',
        fontSize: 'A',
        fontWeight: '600',
        color: 'title',
        text: (el, s) => (s && s.root && s.root.selectedPerson && s.root.selectedPerson.name) || ''
      },
      Email: {
        tag: 'span',
        fontSize: 'Z2',
        color: 'caption',
        text: (el, s) => (s && s.root && s.root.selectedPerson && s.root.selectedPerson.email) || ''
      }
    }
  },

  Meta: {
    flow: 'y',
    gap: 'Y2',

    LocationRow: {
      flow: 'x',
      align: 'center left',
      gap: 'Z',
      Icon: { icon: 'pin', boxSize: 'Z2' },
      Text: {
        tag: 'span',
        fontSize: 'Z2',
        color: 'subtitle',
        text: (el, s) => (s && s.root && s.root.selectedPerson && s.root.selectedPerson.location) || ''
      }
    },

    TimezoneRow: {
      flow: 'x',
      align: 'center left',
      gap: 'Z',
      Icon: { icon: 'clock', boxSize: 'Z2' },
      Text: {
        tag: 'span',
        fontSize: 'Z2',
        color: 'subtitle',
        text: (el, s) => {
          const p = s && s.root && s.root.selectedPerson
          if (!p || !p.timezone) return ''
          try {
            const localTime = new Intl.DateTimeFormat('en-US', {
              timeZone: p.timezone,
              hour: '2-digit',
              minute: '2-digit',
              hour12: false
            }).format(new Date())
            return `${p.timezone.split('/').pop().replace(/_/g, ' ')} · ${localTime}`
          } catch (_) {
            return p.timezone
          }
        }
      }
    }
  },

  Actions: {
    flow: 'x',
    gap: 'Z'
  }
}
